// components/UserDetailModal.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Divider,
  Grid,
  Paper,
} from "@mui/material";

const SectionTitle = ({ title }) => (
  <>
    <Divider sx={{ my: 2 }} />
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
  </>
);

const UserDetailModal = ({ open, onClose, user }) => {
  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>User Complete Details</DialogTitle>

      <DialogContent dividers>

        {/* ---------------- Basic Info ---------------- */}
        <SectionTitle title="Basic Information" />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography><strong>Name:</strong> {user.first_name} {user.last_name}</Typography>
            <Typography><strong>Username:</strong> {user.username}</Typography>
            <Typography><strong>Email:</strong> {user.email}</Typography>
            <Typography><strong>Mobile:</strong> {user.mobile_no}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography><strong>Distinct User Types:</strong> {user.distinct_user_types?.join(", ") || "-"}</Typography>
            <Typography><strong>Distinct Property Types:</strong> {user.distinct_property_types?.join(", ") || "-"}</Typography>
          </Grid>
        </Grid>

        {/* ---------------- Subscription Plans ---------------- */}
        <SectionTitle title="Subscription Plans" />
        {user.user_sub_plan?.length > 0 ? (
          user.user_sub_plan.map((plan) => (
            <Paper key={plan.sub_id} sx={{ p: 2, mb: 2 }}>
              <Typography><strong>Plan:</strong> {plan.plan_name}</Typography>
              <Typography><strong>User Type:</strong> {plan.user_type}</Typography>
              <Typography><strong>Status:</strong> {plan.status ? "Active" : "Inactive"}</Typography>
              <Typography><strong>Expires On:</strong> {new Date(plan.expired_date).toLocaleDateString()}</Typography>
            </Paper>
          ))
        ) : (
          <Typography>No Plans Available</Typography>
        )}

        {/* ---------------- User Properties ---------------- */}
        <SectionTitle title="Posted Properties" />
        {user.user_properties?.length > 0 ? (
          user.user_properties.map((property) => (
            <Paper key={property.property_id} sx={{ p: 2, mb: 2 }}>
              <Typography><strong>Property Name:</strong> {property.property_name}</Typography>
              <Typography><strong>Type:</strong> {property.type}</Typography>
              <Typography><strong>Location:</strong> {property.location}</Typography>
              <Typography><strong>Price:</strong> ₹ {property.price}</Typography>
              {/* <Typography><strong>Status:</strong> {property.Admin_status || "Pending"}</Typography> */}
            </Paper>
          ))
        ) : (
          <Typography>No Properties Posted</Typography>
        )}
        {/* ---------------- Login History ---------------- */}
<SectionTitle title="Login History" />

{user.log_history?.length > 0 ? (
  user.log_history
    .slice() // avoid mutating original
    .reverse() // latest first
    .map((log) => (
      <Paper key={log.log_id} sx={{ p: 2, mb: 2 }}>
        <Typography>
          <strong>Login Time:</strong>{" "}
          {new Date(log.login_time).toLocaleString()}
        </Typography>

        <Typography>
          <strong>Logout Time:</strong>{" "}
          {log.logout_time
            ? new Date(log.logout_time).toLocaleString()
            : "Still Active"}
        </Typography>

        <Typography>
          <strong>Session Status:</strong>{" "}
          {log.logout_time ? "Completed" : "Active"}
        </Typography>
      </Paper>
    ))
) : (
  <Typography>No Login History Available</Typography>
)}

        {/* ---------------- Credits & Referral ---------------- */}
        {/* <SectionTitle title="Credits & Referrals" />
        <Typography><strong>Credit Points:</strong> {user.credit_points}</Typography>
        <Typography><strong>Total Points Earned:</strong> {user.total_points_earned}</Typography>
        <Typography><strong>Total Referrals:</strong> {user.total_referred}</Typography> */}

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserDetailModal;
